// extracted by mini-css-extract-plugin
export var aggregationCell = "_2h-n";
export var aggregationRow = "_2h-m";
export var borderlessSpinnerContainer = "_2h-3";
export var cardLayout = "_2h-6";
export var cardLayoutNoFooter = "_2h-9";
export var cardLayoutPageControl = "_2h-8";
export var closeIcon = "_2h-f";
export var columnHeaderSurface = "_2h-b";
export var columnHeaderSurfaceDragOverlay = "_2h-v";
export var columnHeaderSurfaceResizing = "_2h-s";
export var contextMenuAnchor = "_2h-1";
export var draggableColumnHeader = "_2h-t";
export var draggableColumnHeaderOverlay = "_2h-u";
export var expandIcon = "_2h-g";
export var expanded = "_2h-h";
export var filterDropdown = "_2h-i";
export var filterDropdownDivider = "_2h-d";
export var filterDropdownHeader = "_2h-l";
export var filterDropdownItem = "_2h-k";
export var filterDropdownModal = "_2h-j _2h-i";
export var filterItem = "_2h-c";
export var normalCellWithAdjustableBorder = "_2h-e";
export var pinButtonContainer = "_2h-o";
export var pinIcon = "_2h-p";
export var pinIconActive = "_2h-q";
export var spinner = "_2h-0";
export var spinnerContainer = "_2h-2";
export var tableContainer = "_2h-4";
export var tableContentDraggingColumns = "_2h-a";
export var tableContentInner = "_2h-7";
export var tableContentWrapper = "_2h-5";
export var viewButtonContainer = "_2h-r";